(ns net.kestec.mhda-pilgrimage.lib-ui.form-validator
  (:require
    [clojure.string :as str]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [day8.re-frame.http-fx]

    ))


(defn form-field-validator [VALIDATOR !data]
  (fn [key]
    (let [check-fn (or (get-in VALIDATOR [key :check-fn]) (fn [_ _] true))
          ok? (check-fn (get @!data key) @!data)]
      {:key        key
       :helperText (if ok?
                     (or (get-in VALIDATOR [key :ok-text]) "")
                     (or (get-in VALIDATOR [key :error-text]) "Error"))
       :error      (not ok?)

       })))

(defn form-data-validator [VALIDATOR data]
  ;(println "form-validator called")
  (reduce (fn [c [key key-setup]]
            (let [check-fn (or (:check-fn key-setup) (fn [_ _] true))
                  ok? (check-fn (get data key) data)]
              (assoc c
                :keys (assoc (:keys c) key ok?)
                :validatorInfoText (if ok? (:validatorInfoText c) (conj (:validatorInfoText c) (or (:missing-text key-setup) (name key))))
                :formMissingText (if ok? (:validatorInfoText c) (conj (:validatorInfoText c) (or (:missing-text key-setup) (name key))))
                :valid (and (:valid c) ok?)
                )))
          {:keys              {}
           :validatorInfoText []
           :valid             true
           }
          VALIDATOR))

(defn form-validator [VALIDATOR !data]
  ;(println "form-validator called")
  (reduce (fn [c [key key-setup]]
            (let [check-fn (or (:check-fn key-setup) (fn [_ _] true))
                  ok? (check-fn (get @!data key) @!data)]
              (assoc c
                :keys (assoc (:keys c) key ok?)
                :validatorInfoText (if ok? (:validatorInfoText c) (conj (:validatorInfoText c) (or (:missing-text key-setup) (name key))))
                :formMissingText (if ok? (:validatorInfoText c) (conj (:validatorInfoText c) (or (:missing-text key-setup) (name key))))
                :valid (and (:valid c) ok?)
                )))
          {:keys              {}
           :validatorInfoText []
           :valid             true
           }
          VALIDATOR)
  )




(defn check-min-text-length [length]
  (fn [v _]
    ;(println "check-min-text-length " length "<--" v)
    (>= (count (str v)) length)))

(defn check-not-nil []
  (fn [v _]
    ;(println "check-not-nil "  "<--" v)
    (not (nil? v))))

(defn check-true []
  (fn [v _]
    (true? v)))

(defn check-count [& [min max]]
  (fn [v _]
    ;(println "check-not-nil "  "<--" v)
    (>= (count v) (or min 0))))

(defn check-integer [& [min max]]
  (fn [v _]
    (and (integer? (try (int v) (catch js/Error e nil)))
         (or (nil? min) (>= v min))
         (or (nil? max) (<= v max))
         )))

(defn check-is-email []
  (fn [v _]
    ;(println "check-is-email "  "<--" (re-matches #"^\S+@\S+\.\S+$" (str v)))
    (re-matches #"^\S+@\S+\.\S+$" (str v))))

(defn check-is-phone []
  (fn [v _]
    ;(println "check-is-phone "  "<--" (str/replace  (str v) #" " "" )"`")
    (re-matches #"^\+\d{7,15}$" (str/replace  (str v) #" " "" ))))

(defn check-date-is-age []
  (fn [v _]
    ;(println "check-date-is-age " "<--" v)
    (not (nil? v))))

(defn check-date-is-future []
  (fn [v _]
    ;(println "check-date-is-future " "<--" v)
    (not (nil? v))))


(defn check-combine-and [data-condition-fn check-fn]
  (fn [v data]
    (and
      (data-condition-fn data)
      (check-fn v data))))

(defn check-combine-or [data-condition-fn check-fn]
  (fn [v data]
    (println "data-condition-or-fn " (:missing-text data) " ::" (data-condition-fn data) "||" v "->" (check-fn v data))
    (or
      (data-condition-fn data)
      (check-fn v data))))


